import gql from 'graphql-tag'

export const libraryImagesQuery = gql`
    query libraryImages($eventSlug: EventID!) {
        event(id: $eventSlug){
            organization {
                id
                images {
                    edges {
                        node {
                            id
                            file
                        }
                    }
                }
            }
        }
    }
`

export const adminOrganizationImagesQuery = gql`
    query organizationImages($organizationId: ID!) {
        organization(id: $organizationId) {
            images {
                edges {
                    node {
                        id
                        file
                    }
                }
            }
        }
    }
`
